export default "__VITE_ASSET__BFnkYc1S__"